<template>
  <div>
    <apply-step ref="applyStepRef" v-if="!isReadonly" />

    <div class="container">
      <div class="pb22">
        <template v-if="!isReadonly">
          <div v-if="applymentDetail.applymentStatus == 'QUOTATION_AUDIT_PASS'">
            <el-result icon="success" :title="$t('enroll.quotation.theBid')" :subTitle="$t('enroll.quotation.theBidTipe')"></el-result>
          </div>
        </template>
        <p class="fs16 lh20 pb6 fwb orange">
          {{ $t("enroll.quotation.reminders") }}
        </p>
        <p class="fs16 lh20 pb6 fwb orange">
          {{ $t("enroll.quotation.describe01") }}
        </p>
        <p class="fs16 lh20 pb6 fwb orange">
          {{ $t("enroll.quotation.describe02") }}
        </p>
        <p class="fs16 lh20 pb6 fwb orange">
          {{ $t("enroll.quotation.describe03") }}
        </p>
      </div>
      <el-form ref="dataForm" :model="dataForm" label-width="0px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }">
        <el-form-item
          label=""
          prop="inquiryStatement"
          ref="inquiryStatement"
          class="pb10"
          :rules="[
            {
              required: true,
              message: this.$t('common.placeholder.enter'),
              trigger: 'submit',
            },
          ]"
          v-if="applymentDetail.applymentStatus == 'DRAFT' || applymentDetail.applymentStatus == 'QUOTATION_AUDIT_PASS'"
        >
          <p class="pb8 fs16 fwb lh32">
            {{ $t("enroll.quotation.requirements") }}
          </p>
          <el-input type="textarea" v-model="dataForm.inquiryStatement" :rows="6" :placeholder="$t('enroll.quotation.demand')" class="wd800"></el-input>
        </el-form-item>

        <!-- 信息 -->
        <div v-if="applymentDetail.applymentStatus != 'DRAFT'">
          <div class="pb30" v-if="applymentDetail.applymentStatus != 'QUOTATION_AUDIT_PASS'">
            <p class="pb8 fs16 fwb">
              {{ $t("enroll.quotation.requirements") }}
            </p>
            <p class="fs12 preLine">
              <!-- {{ applymentDetail.inquiryStatement }} -->
              <el-input type="textarea" :value="dataForm.inquiryStatement" :rows="6" :placeholder="$t('enroll.quotation.demand')" disabled class="wd800"></el-input>
            </p>
          </div>
          <div v-if="isCoordinator">
            <div class="pb30" v-if="applymentDetail.isRenew || applymentDetail.isLaterService">
              <p class="pb8 fs16 fwb">
                <span v-if="applymentDetail.isRenew">{{ $t("enroll.quotation.linkedTransactionRenewed") }}</span>
                <span v-if="applymentDetail.isLaterService">{{ $t("enroll.quotation.linkedTransactionSupplements") }}</span>
              </p>
              <p class="fs12">
                {{ applymentDetail.excApplymentNo }}
              </p>
            </div>
          </div>
          <div class="pb30">
            <p class="pb8 fs16 fwb">
              {{ $t("enroll.quotation.quotationNumber") }}
            </p>
            <p class="fs12">
              {{ applymentDetail.applymentNo }}
            </p>
          </div>
          <div class="pb30">
            <p class="pb8 fs16 fwb">
              {{ $t("enroll.quotation.lastSubmittedDate") }}
            </p>
            <p class="fs12">
              {{ applymentDetail.latestInquiryTime }}
            </p>
          </div>
        </div>

        <template v-if="!isReadonly">
          <div class="pt50 pb26 fxRow" v-if="initOk">
            <!-- 上一步 -->
            <el-button
              type="primary"
              :disabled="submitLoading || nextLoading"
              @click="lastStep"
              class="pl20 pr20 fz16 mr16"
              v-if="!(isCoordinator && applymentDetail.isLaterService)"
            >
              {{ $t("common.button.last") }}
            </el-button>
            <!-- 报价申请 – 提交 -->
            <el-button
              :loading="submitLoading"
              :disabled="nextLoading"
              @click="applicationsSubmit"
              class="pl20 pr20 fz16 mr16"
              v-if="applymentDetail.applymentStatus == 'DRAFT' || applymentDetail.applymentStatus == 'QUOTATION_AUDIT_PASS'"
            >
              {{ $t("enroll.quotation.applicationsButton") }}
            </el-button>
            <!-- 下一步 -->
            <el-button
              type="primary"
              :loading="nextLoading"
              :disabled="submitLoading"
              @click="nextStep"
              class="pl20 pr20 fz16"
              v-if="applymentDetail.applymentStatus == 'QUOTATION_AUDIT_PASS'"
            >
              {{ $t("common.button.next") }}
            </el-button>
          </div>
        </template>
      </el-form>
    </div>
  </div>
</template>

<script>
import ApplyStep from "@/components/ApplyStep";
import { validateLocation } from "@/utils/common";
import pageGuardMixin from "@/mixins/pageGuardMixin";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "EnrollQuotation",
  mixins: [pageGuardMixin],
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ApplyStep,
  },
  data() {
    return {
      initOk: false, // 初始化是否完成
      businessType: null,
      dataForm: {
        inquiryStatement: null,
      },
      submitLoading: false,
      nextLoading: false,
    };
  },
  computed: {
    ...mapState("user", ["isCoordinator"]),
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail", "saveApplyment", "inquireApplyment"]),
    // 保存接口 - http
    saveHttp(type) {
      this.saveRequestState = 1;
      // 参数整理
      const currentStepIndex = this.$refs.applyStepRef.getCurrentStepIndex();
      const lastStayPage = type == "next" ? currentStepIndex + 1 : currentStepIndex;
      let params = {
        lastStayPage,
      };
      // 保存当前状态
      params.applymentStatus = this.applymentDetail.applymentStatus;
      return new Promise((resolve, reject) => {
        this.saveApplyment(params)
          .then(res => {
            this.saveRequestState = 2;
            resolve(res);
          })
          .catch(err => {
            this.saveRequestState = 3;
            reject(err);
          });
      });
    },
    // 报价申请 - http
    applicationsHttp() {
      return new Promise((resolve, reject) => {
        this.inquireApplyment({
          inquiryStatement: this.dataForm.inquiryStatement,
        })
          .then(res => {
            // 点击本按钮提交报价申请，我们的工作人员将在收到报价咨询后的48小时内联系你、了解你的需求以及提供你定制化服务的报价。
            this.$alert(this.$t("enroll.quotation.toolTip"), this.$t("common.success.submit"), {
              confirmButtonText: this.$t("common.success.know"),
              type: "success",
              center: true,
              callback: action => {
                // this.$router.replace({ path: "/enroll" });
                // 初始化
                this.pageInit();
              },
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 报价申请 – 提交
    applicationsSubmit() {
      this.$refs["dataForm"].validate(async (valid, object) => {
        if (valid) {
          try {
            this.submitLoading = true;
            // 保存
            await this.saveHttp("save");
            // 报价申请 - http
            await this.applicationsHttp();
          } catch (err) {
            console.error(err);
          } finally {
            this.submitLoading = false;
          }
        } else {
          validateLocation(object, this);
          return false;
        }
      });
    },
    // 上一步
    lastStep() {
      this.$refs.applyStepRef.toPreviousStep();
    },
    // 下一步
    async nextStep() {
      try {
        this.nextLoading = true;
        // 保存
        await this.saveHttp("next");
        this.$refs.applyStepRef.toNextStep();
      } catch (err) {
        console.error(err);
        this.nextLoading = false;
      }
    },
    // 页面初始化数据整理
    pageInit() {
      this.fetchApplymentDetail(this.applyId).then(data => {
        // 检查当前页面的申请步骤是否存在(pageGuardMixin中的方法)
        this.checkCurrentPageHasApplyStep();
        // 检查当前页面的申请状态能否进入该页面(pageGuardMixin中的方法)
        this.checkCurrentPageSupportApplymentStatus();
        // 数据初始化处理
        this.dataInit();

        this.initOk = true;
      });
    },
    // 数据初始化处理
    dataInit() {
      const applymentDetailCopy = JSON.parse(JSON.stringify(this.applymentDetail));
      // 业务类型
      this.businessType = applymentDetailCopy.businessType;
      this.$set(this.dataForm, "inquiryStatement", applymentDetailCopy.inquiryStatement);
    },
  },
  created() {
    if (this.isReadonly) {
      this.dataInit();
    } else {
      // 检查url是否携带参数id (pageGuardMixin中的方法)
      this.checkPathQueryHasId();
      // 检查url是否存在参数(id)
      if (this.$route.query.id) {
        this.applyId = this.$route.query.id;
        this.pageInit();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-textarea.is-disabled .el-textarea__inner {
    color: #011a45 !important;
  }
}
</style>
